import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconSettings.tsx
const IconSettings = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M3.34 17a10 10 0 0 1-.978-2.326 3 3 0 0 0 .002-5.347A10 10 0 0 1 4.865 4.99a3 3 0 0 0 4.631-2.674 10 10 0 0 1 5.007.002 3 3 0 0 0 4.632 2.672A10 10 0 0 1 20.66 7c.433.749.757 1.53.978 2.326a3 3 0 0 0-.002 5.347 10 10 0 0 1-2.5 4.337 3.001 3.001 0 0 0-4.632 2.674 10 10 0 0 1-5.007-.002 3 3 0 0 0-4.632-2.672A10 10 0 0 1 3.34 17m5.66.196a5 5 0 0 1 2.25 2.77q.75.071 1.5 0a5 5 0 0 1 2.25-2.77 5 5 0 0 1 3.525-.564q.435-.614.748-1.298A5 5 0 0 1 18 12c0-1.26.47-2.437 1.273-3.334q-.315-.684-.75-1.298A5 5 0 0 1 15 6.804a5 5 0 0 1-2.25-2.77q-.75-.071-1.499-.001a5 5 0 0 1-2.25 2.77 5 5 0 0 1-3.526.565q-.436.614-.748 1.298A5 5 0 0 1 6 12a5 5 0 0 1-1.273 3.334q.315.684.75 1.298A5 5 0 0 1 9 17.196M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
	})]
});
var IconSettings_default = forwardRef(IconSettings);
//#endregion
export { IconSettings_default as default };
